export const ExtraInfoData = [
  {
    name: "kulturform",
    title: "Beskrivning av kulturformer",
    items: [
      {
        namn: "Föreläsning",
        beskrivning: "Ett strukturellt och förberett framförande",
      },
      {
        namn: "Dramatisk framställning",
        beskrivning: "Teaterföreställning",
      },
      {
        namn: "Film/foto/bild",
        beskrivning: "Filmvisning",
      },
      {
        namn: "Dans",
        beskrivning: "Dansföreställning, dansuppvisning",
      },
      {
        namn: "Litteratur",
        beskrivning: "Uppläsning, poesiafton",
      },
      {
        namn: "Konst/konsthantverk",
        beskrivning: "Bildkonst, konsthantverk",
      },
      {
        namn: "Tvärkulturell verksamhet",
        beskrivning: "Används då arrangemanget har fler olika kulturformer",
      },
      {
        namn: "Sång/musik",
        beskrivning:
          "Musikframställning, konsert, körsång, övrig sång, folkmusik, klassisk och nutida musik, jazz/improviserad musik, pop/rockmusik",
      },
      {
        namn: "Utställningar",
        beskrivning:
          "Utställningar kan enligt Folkbildningsrådets anvisningar, endast rapporteras en gång per plats den visas, oavsett visningstidens längd",
      },
    ],
  },
];
